<template>
  <div
    :class="[preview && 'lp-input-list-preview']"
    :data-ua-unique-id="dataUaUniqueId"
  >
    <span class="lp-input-label font-weight-medium">
      {{ labelTop }}
      <span v-if="!preview && required" class="text-blue">*</span>
    </span>
    <div class="ly-col">
      <div v-for="(value, index) in values" :key="index" class="ly-row">
        <lp-select
          v-if="options"
          v-model="value[typeBy]"
          :options="options"
          :label-by="optionsLabel as string"
          :track-by="optionsValue as string"
          :data-ua-multiple-id="`${
            uaIdSelect ? `${uaIdSelect}-${index}` : undefined
          }`"
          :preview="preview || false"
          style="max-width: 10rem"
          class="w-100"
          compact
        />
        <component
          :is="inputTypeEnum"
          :key="index"
          ref="componentWrapper"
          v-model="value[trackBy]"
          :disabled="disabled"
          :prefix-icon="prefixIcon"
          :format="format"
          :data-ua-multiple-id="`${
            uaIdInput ? `${uaIdInput}-${index}` : undefined
          }`"
          :preview="preview"
        />
        <lp-button
          v-if="!preview && values.length > 1"
          type="red-100"
          icon="trash"
          text
          class="text-error"
          :data-ua-multiple-id="`${
            uaIdRemoveButton ? `${uaIdRemoveButton}-${index}` : undefined
          }`"
          @click="removeItem(index)"
        />
        <lp-button
          v-if="!preview"
          type="neutral"
          icon="star"
          text
          :class="value[primaryBy] ? 'text-blue' : 'text-gray'"
          :data-ua-multiple-id="`${
            uaIdPrimaryButton ? `${uaIdPrimaryButton}-${index}` : undefined
          }`"
          @click="makePrimary(index)"
        />
      </div>
      <div v-if="!preview" class="ly-row">
        <lp-button type="neutral" icon="plus" text @click="addItem()">
          {{ t('LpInputList.AddNew') }}
        </lp-button>
      </div>
    </div>
    <span
      v-if="message"
      class="lp-input-message mt-half d-flex"
      :class="[
        status ? `lp-input-message-${status}` : `lp-input-message-danger`,
        disabled && `lp-input-message-disabled`,
      ]"
    >
      {{ message }}
    </span>
    <span v-if="!message" class="lp-input-message mt-half d-flex text-gray">
      {{ helper }}
    </span>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { NumberFormat } from '@/helpers/numbers'
import { t } from '@/plugins/i18n'
import { inputTypes, inputTypesKeys } from './inputTypes'

defineOptions({
  name: 'lp-input-list',
  inheritAttrs: false,
})

export interface ItemInterface {
  [key: string]: unknown
}

interface Props {
  status?: string
  message?: string | null
  helper?: string | null
  disabled?: boolean
  labelTop: string
  modelValue: []
  options: []
  prefixIcon?: string | null
  format?: string | null
  trackBy?: string | null
  typeBy?: string | null
  optionsLabel?: string | null
  optionsValue?: string | null
  primaryBy?: string | null
  categoryBy?: string | null
  required?: boolean | null
  inputType?: inputTypesKeys
  preview?: boolean | null
  dataUaUniqueId?: string
  uaIdSelect?: string | null | false
  uaIdInput?: string | null | false
  uaIdRemoveButton?: string | null | false
  uaIdPrimaryButton?: string | null | false
}

const props = withDefaults(defineProps<Props>(), {
  status: 'neutral',
  message: null,
  helper: null,
  disabled: false,
  modelValue: undefined,
  prefixIcon: null,
  format: NumberFormat.Decimal,
  trackBy: 'value',
  typeBy: 'type',
  optionsLabel: 'label',
  optionsValue: 'value',
  primaryBy: 'isPrimary',
  required: false,
  inputType: 'TEXT',
  preview: false,
  dataUaUniqueId: 'unique-input-list',
  uaIdSelect: 'select',
  uaIdInput: 'input',
  uaIdRemoveButton: 'remove-button',
  uaIdPrimaryButton: 'make-primary-button',
})

const newValue = ref(null)
const values = ref<ItemInterface[]>(props.modelValue)
const inputTypeProp = ref<inputTypesKeys>(
  props.inputType.toUpperCase() as inputTypesKeys,
)

const inputTypeEnum = inputTypes[inputTypeProp.value]
onMounted(() => {
  // console.log(inputTypeEnum)
})

const addItem = () => {
  values.value.push({
    [props.trackBy as string]: null,
    [props.typeBy as string]: null,
    [props.primaryBy as string]: false,
    [props.typeBy as string]: null,
  })
}
const removeItem = (index: number) => {
  values.value.splice(index, 1)
}
const makePrimary = (index: number) => {
  values.value.forEach((value) => {
    value[props.primaryBy as string] = false
  })
  values.value[index][props.primaryBy as string] = true
}
const input = ref<number | null>(null)
</script>

<style scoped>
.ly-row > div {
  flex: 1;
}
</style>
